import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('incident', 'incidents');

const customActions = {
  async UPDATE_incidentModel({ rootGetters }, obj) {
    const {
      id,
      incidentType,
      description,
      imageUrl,
    } = obj;
    const incidentModel = {
      id,
      incidentType,
      description,
      imageUrl,
      location: obj.location?.geography?.wellKnownText ?? null,
    };
    const data = await odata.o(rootGetters)
      .put('updateIncident', incidentModel)
      .query();
    return data;
  },
  async CREATE_incidentModel({ rootGetters }, obj) {
    const {
      incidentType,
      description,
      imageUrl,
    } = obj;
    const incidentModel = {
      incidentType,
      description,
      imageUrl,
      location: obj.location?.geography?.wellKnownText ?? null,
    };
    const data = await odata.o(rootGetters)
      .post('newIncident', incidentModel)
      .query();
    return data;
  },
  async LOAD_incidents({ rootGetters, commit }) {
    const data = await odata.o(rootGetters)
      .get('incidents')
      .query({
        $filter: 'IsDeleted eq false',
        $orderby: 'created DESC',
      });
    commit('SET_incidents', data);
    return data;
  },
  async LOAD_incidentsInMyArea({ rootGetters, commit }, pos) {
    try {
      const data = await odata.o(rootGetters)
        .post('findIncidentsInMyArea', pos)
        .query();
      commit('SET_incidentsInMyArea', data);
      return data;
    } catch (error) {
      commit('SET_incidentsInMyArea', null);
      return null;
    }
  },
};

export default { ...actions, ...customActions };
